import { CroYVault__factory } from '@contracts';
import { BigNumber } from '@ethersproject/bignumber';
import { parseUnits } from 'ethers/lib/utils';
import { VenoSDKModule } from './base';
import { wrapSdkTransaction } from './util';
export default class CroYVaultModule extends VenoSDKModule {
    constructor(sdk) {
        super(sdk);
        this.contractFactory = CroYVault__factory;
        this.contractAddress = this.sdk.addresses.croYVault;
    }
    async deposit(amount) {
        return await wrapSdkTransaction(this.getContract().deposit({
            value: amount,
        }));
    }
    async estimateGasForDeposit() {
        const { maxFeePerGas } = await this.sdk.provider.getFeeData();
        const gasUnits = await this.getContract().estimateGas.deposit({
            value: parseUnits('0.00000001', 18),
        });
        if (!maxFeePerGas)
            return BigNumber.from(0);
        return maxFeePerGas.mul(gasUnits);
    }
    async withdraw(amount) {
        return await wrapSdkTransaction(this.getContract()['withdraw(uint256)'](amount));
    }
}
